import { takeEvery } from 'redux-saga/effects';
import { DASHBOARD_MODULE } from '../../../configs/moduleNames';

import {
  LOAD_LIST_CAMERA, LOAD_LIST_PARKING_METER, LOAD_STAT_CAMERA, LOAD_STAT_PARKING_METER,
} from '../actions';

import loadStatParkingMeter from './loadStatParkingMeter';
import loadStatCamera from './loadStatCamera';
import loadListParkingMeter from './loadListParkingMeter';
import loadListCamera from './loadListCamera';

export default function* watchClient() {
  yield takeEvery(DASHBOARD_MODULE + LOAD_STAT_PARKING_METER, loadStatParkingMeter);
  yield takeEvery(DASHBOARD_MODULE + LOAD_STAT_CAMERA, loadStatCamera);
  yield takeEvery(DASHBOARD_MODULE + LOAD_LIST_PARKING_METER, loadListParkingMeter);
  yield takeEvery(DASHBOARD_MODULE + LOAD_LIST_CAMERA, loadListCamera);
}
